<div class="grid my-6">
    <div class="
        col-12
        sm:col-12
        md:col-4
        lg:col-4
        xl:col-5
        ">
        <div style="border: solid 0.5px #9a9a9a; border-radius: 5px; padding: 5px; text-align: center;">
            <a *ngIf="eventNew.route != ''" [routerLink]="eventNew.route"><img [src]="eventNew.image" alt="" style="max-width: 100%; max-height: 15rem;"></a>
        </div>
    </div>
    <div class="
        col-12
        sm:col-12
        md:col-8
        lg:col-8
        xl:col-7
        flex
        flex-column
        lg:justify-content-center
    "
    style="border-bottom: solid 1px #9A9A9A;"
    >
      <h2 style="margin: 0px;">{{ eventNew.title }}</h2>
      <h5 style="overflow: hidden; white-space: nowrap; color: #606060;text-overflow: ellipsis !important;">{{textWithoutTags}}</h5>
      <div class="grid flex justify-content-between px-3">
          <p class="text-sm">{{label}}:  {{date | date}}</p>
          <p-button (click)="sendWithState(eventNew)" label="Ver más" styleClass="p-button-info p-button-text" icon="pi pi-angle-double-right" iconPos="right"></p-button>
      </div>
      <p *ngIf="eventNew.tags!.length > 0">
        Tags: <p-tag *ngFor="let itemTag of eventNew.tags" [style]="{margin: '1.5px'}" value="{{itemTag}}" [rounded]="true"></p-tag>
    </p>
    </div>
</div>
